import React from "react";

import { IConfirmDialogContext } from "./confirm-dialog-provider";

export const ConfirmDialogContext = React.createContext<
  IConfirmDialogContext | undefined
>(undefined);

export const useConfirmDialog = (): IConfirmDialogContext => {
  const context = React.useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error(
      "useConfirmDialog must be used within a ConfirmDialogProvider"
    );
  }
  return context;
};
